import { SwatchBook } from "lucide-react";

import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";
import { cn } from "@/lib/utils";

interface SiblingRankBadgeProps {
  asin: string;
  className?: string;
}

export function SiblingRankBadge({ asin, className }: SiblingRankBadgeProps) {
  if (asin.trim() === "") {
    return null;
  }

  const label = `Rank from variant: ${asin}`;

  return (
    <Tooltip delayDuration={150}>
      <TooltipTrigger asChild>
        <button
          type="button"
          aria-label={label}
          onClick={(e) => e.stopPropagation()}
          className={cn(
            "inline-flex h-4 w-4 shrink-0 items-center justify-center rounded-full text-current transition-colors hover:bg-foreground/25 data-[state=delayed-open]:bg-foreground/25 data-[state=instant-open]:bg-foreground/25",
            className,
          )}
        >
          <SwatchBook className="h-3 w-3" strokeWidth={2} aria-hidden />
        </button>
      </TooltipTrigger>
      <TooltipContent>{label}</TooltipContent>
    </Tooltip>
  );
}
